
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { LoaderService } from '../service/loader.service';
import { UserService } from '../service/user.service';
import { ChartService } from '../service/chart.service';

import { BaseComponent } from '../shared/components/base.component';
import { DatepickerComponent, DatepickerOptions } from 'ng2-datepicker';
import { FilterDetail } from 'src/app/model/lookup/FilterDetail';
import { Chart} from 'chart.js';
import { ChartConfiguration, ChartType } from 'chart.js';
import { ResponseData } from '../service/model/response.model';

import { RolesEnum } from '../service/enums/role.enum';
import { PaymentStatusEnum } from '../service/enums/paymentStatus.enum';
import { RequestStatusEnum } from '../service/enums/requestStatus.enum';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent extends BaseComponent implements   OnDestroy {
//===========================
@ViewChild('doughnutCanvasCategory') doughnutCanvasCategory!: ElementRef;
  chartCategory: any;
@ViewChild('doughnutCanvas') doughnutCanvas!: ElementRef;
  chart: any;
  // @ViewChild("MontlySubmittedOrderCurrentYearComponent", { static: false }) montlySubmittedOrderCurrentYearComponent: DatepickerComponent


ChartData:ResponseData=null;
showAdminDesktop:boolean=true;
//currentIntervalId: any = null;
  public doughnutChartLabels: string[] = [];
  public doughnutChartData:number[]=[]; 
  public doughnutChartLabelsIPQ: string[] = [];
  public doughnutChartDataIPQ:number[]=[]; 
  public doughnutChartType: ChartType = 'doughnut';
  public doughnutColor: string[] = [];

_fromDate:string="";
_toDate:string="";
requestsSumbited :number=0;
inProgress :number=0;
completed :number=0;
deleted :number=0;
submitedOrderDiff:number=0;
deletedOrderDiff:number=0;
submitedOrderDiffPercentage:number=0;
deletedOrderDiffPercentage:number=0;
totalEarning :number=0;

//paymentStatusEnum: any;
  @ViewChild("fromDate", { static: false }) fromDate: DatepickerComponent
  @ViewChild("toDate", { static: false }) toDate: DatepickerComponent

   selectedFilters: FilterDetail = new FilterDetail();

  // selectedFilters = {
  //   fromDate: new Date(), // or any specific date
  //   toDate: new Date()
  // };

  fromDatePickeroptions: DatepickerOptions = {
      placeholder:this.lang==="en"?'From Date':'من تاريخ', 
      format: 'dd MMM, yyyy', // date format to display in input
      formatTitle: 'dd MMM, yyyy',
      formatDays: 'EEEEE',
     
      
      
    };
  toDatePickeroptions: DatepickerOptions = {
      placeholder: this.lang==="en"?'To Date':'الى تاريخ',
      format: 'dd MMM, yyyy', // date format to display in input
      formatTitle: 'dd MMM, yyyy',
      formatDays: 'EEEEE',
  };


  clearFromDate() {
    this.fromDate.displayValue = null;
    this.fromDate.innerValue = new Date();
    this.selectedFilters.fromDate = null;
    this.selectedFilters.fromDateYear = null;
    this.selectedFilters.fromDateMonth = null;
    this.selectedFilters.fromDateDay = null;
  }

  clearToDate() {
    this.toDate.displayValue = null;
    this.toDate.innerValue = new Date();
    this.selectedFilters.toDate = null;
    this.selectedFilters.toDateYear = null;
    this.selectedFilters.toDateMonth = null;
    this.selectedFilters.toDateDay = null;
  }
 
  //#Region for all employee
  showEmployeeDesktop:boolean=true;
  dailyOrder: number = 0;
  dailyCompleted: number = 0;
  dailyInProgress: number = 0;
  dailyCancelled: number = 0;
  dailyAmount: number = 0;

  dailyTotalOrder: number = 0;
  dailyTotalCompleted: number = 0;
  dailyTotalInProgress: number = 0;
  dailyTotalCancelled: number = 0;
  dailyTotalAmount: number = 0;

  showCancelledOrders: boolean = false;
  showTotalOrders: boolean = false;
  dashboardTodayOrders: any[];
  dashboardDelayedOrders: any[];
  currentIntervalId: any = null;
  fontAwesomeRate = "3";
  fontAwesomeRate1 = "2";
  fontAwesomeRate2 = "1";
  fontAwesomeRate3 = "3";
  showTotalRevenue: boolean = false;
  hideDelayed: boolean = false;
  hidePaymentStatus: boolean = false;
  chartDonutData = [{
    label: "Download Sales",
    value: 19
  },
  {
    label: "In-Store Sales",
    value: 48
  },
  {
    label: "Mail-Order Sales",
    value: 32
  }
  ];
  public chartDonutOptions = {
    colors: ['#3eaaf4', '#57c293', '#dddddd']
  }
  paymentStatusEnum: any;



 //#endregion

  constructor( 
    private userService: UserService, 
    private loaderService: LoaderService,    
    private chartService:ChartService
  ) 
    {
    super();
    this.showTotalRevenue = this.userProfileService.isRoleExists(RolesEnum.SuperAdmin) || this.userProfileService.isRoleExists(RolesEnum.Accountant);
    this.hideDelayed = this.userProfileService.isOnlyRoleExists(RolesEnum.Court);
    this.hidePaymentStatus = this.userProfileService.isOnlyRoleExists(RolesEnum.Court);
    this.showCancelledOrders = this.userProfileService.isRoleExists(RolesEnum.SuperAdmin);
    this.showTotalOrders = this.userProfileService.isRoleExists(RolesEnum.SuperAdmin);
    this.paymentStatusEnum = PaymentStatusEnum;
    this.showAdminDesktop=this.userProfileService.isRoleExists(RolesEnum.SuperAdmin);
    this.showEmployeeDesktop=!this.showAdminDesktop;
   // console.log("showAdminDesktop :-",this.showAdminDesktop, "this.showEmployeeDesktop :-",this.showEmployeeDesktop);
  }

  ngOnInit() {
    if(this.showEmployeeDesktop){
      this.getUserDashboardCharts();

      this.currentIntervalId = setInterval(() => {
        this.getUserDashboardCharts();
      }, 60 * 1000);
    }
  }
  
  ngAfterViewInit() {
    if(this.showAdminDesktop){
    this.getAdminDashboardCharts();
    }
  }

  getAdminDashboardCharts() {

    this.doughnutChartLabels=[];
    this.doughnutChartData=[]; 
    this.loaderService.show();
     
      if (this.selectedFilters.fromDate && this.selectedFilters.fromDate !== null) {
      this.selectedFilters.fromDateYear = this.selectedFilters.fromDate.getFullYear();
      this.selectedFilters.fromDateMonth = this.selectedFilters.fromDate.getMonth() + 1;
      this.selectedFilters.fromDateDay = this.selectedFilters.fromDate.getDate();
    } else {
      this.selectedFilters.fromDateYear = null;
      this.selectedFilters.fromDateMonth = null;
      this.selectedFilters.fromDateDay = null;
    }

    if (this.selectedFilters.toDate && this.selectedFilters.toDate !== null) {
      this.selectedFilters.toDateYear = this.selectedFilters.toDate.getFullYear();
      this.selectedFilters.toDateMonth = this.selectedFilters.toDate.getMonth() + 1;
      this.selectedFilters.toDateDay = this.selectedFilters.toDate.getDate();
    } else {
      this.selectedFilters.toDateYear = null;
      this.selectedFilters.toDateMonth = null;
      this.selectedFilters.toDateDay = null;
    }

    if(this.selectedFilters.fromDateYear !==null && this.selectedFilters.fromDateMonth !==null && this.selectedFilters.fromDateDay!==null)
    {
       this._fromDate=this.selectedFilters.fromDateYear+'/'+this.selectedFilters.fromDateMonth+'/'+this.selectedFilters.fromDateDay
    }

    if(this.selectedFilters.toDateYear !==null && this.selectedFilters.toDateMonth !==null && this.selectedFilters.toDateDay!==null)
    {    
       this._toDate=this.selectedFilters.toDateYear+'/'+this.selectedFilters.toDateMonth+'/'+this.selectedFilters.toDateDay
    }
  
console.log("_fromDate-:",this._fromDate,"_toDate-:",this._toDate)
     this.userService.GetDashboardData(this._fromDate,this._toDate).subscribe(
      ress => {
        
        this.loaderService.hide();
         if (ress.successed) {
          var data = ress.data;
          this.ChartData=ress;
          data.totalEarning     
          //console.log("data.dashboardServiceStatus",data.dashboardServiceStatus);
          this.requestsSumbited=data.dashboardServiceStatus.requestsSumbited;
          this.inProgress = data.dashboardServiceStatus.inProgress;
          this.completed = data.dashboardServiceStatus.completed;
          this.deleted = data.dashboardServiceStatus.deleted;
          this.submitedOrderDiff=data.dashboardServiceStatus.submitedOrderDiff;
          this.submitedOrderDiffPercentage=data.dashboardServiceStatus.submitedOrderDiffPercentage;
          this.deletedOrderDiff=data.dashboardServiceStatus.deletedOrderDiff;
          this.deletedOrderDiffPercentage=data.dashboardServiceStatus.deletedOrderDiffPercentage;
          //Total Earning
          this.totalEarning=data.totalEarning;
   
          
           //Income per Quarter Doughnut Chart
           this.doughnutChartLabelsIPQ=['Q1','Q2','Q3','Q4'];
           this.doughnutChartDataIPQ=[data.dashboardIncomePerQuarterChart.quarter1,
                                      data.dashboardIncomePerQuarterChart.quarter2,
                                      data.dashboardIncomePerQuarterChart.quarter3,
                                      data.dashboardIncomePerQuarterChart.quarter4]
  
          this.doughnutColor = this.chartService.generateColors(this.doughnutChartDataIPQ.length);//['#025a49ff', '#0d9e03ff', '#99c59dff', '#cce5d1ff']
          
          this.chartService.renderChart(this.chart,this.doughnutCanvas,this.doughnutChartLabelsIPQ,this.doughnutChartDataIPQ,this.doughnutColor,true);
          
          //MonthlySubmitedOrder

         } else {
          this.toastrAlertService.errorToastr(ress.errorMessage);
        }
      },
      error => {
        this.loaderService.hide();
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
        }
      }
    )
  }
  //   generateColors(count: number): string[] {
  //   const palette = ['#0d3b1aff', '#1f7346ff', '#5ab892ff', '#b9deb4ff', '#747673ff', '#bfbdbbff'];
  //   return palette.slice(0, count);
  // }
  
//#region Employee Dashboard
  getUserDashboardCharts() {
    this.dailyOrder = 0;
    this.dailyInProgress = 0;
    this.dailyCompleted = 0;
    this.dailyAmount = 0;

    this.dailyTotalOrder = 0;
    this.dailyTotalInProgress = 0;
    this.dailyTotalCompleted = 0;
    this.dailyTotalAmount = 0;
    this.dailyTotalCancelled = 0;


    this.loaderService.show();
    this.userService.GetDashboards().subscribe(
      res => {
        this.loaderService.hide();
        if (res.successed) {
          var data = res.data;
          this.dashboardTodayOrders = data.dashboardTodayOrders;
          this.dashboardDelayedOrders = data.dashboardDelayedOrders;
          var that = this;
          data.dashboardSingleCharts.forEach(function (value) {
            if (value.requestStatusId === -1) {
              that.dailyOrder = value.totalCount;
              that.dailyAmount = value.totalAmount;
            }
            if (value.requestStatusId === RequestStatusEnum.Completed) {
              that.dailyCompleted = value.totalCount;
            }
            if (value.requestStatusId !== RequestStatusEnum.Completed && value.requestStatusId !== RequestStatusEnum.Cancelled && value.requestStatusId !== RequestStatusEnum.Submitted && value.requestStatusId !== -1) {
              that.dailyInProgress = value.totalCount;
            }
            if (value.requestStatusId === RequestStatusEnum.Cancelled) {
              that.dailyCancelled = value.totalCount;
            }
          })

          if (data.dashboardSingleTotalCharts && data.dashboardSingleTotalCharts !== null) {
            data.dashboardSingleTotalCharts.forEach(function (value) {
              that.dailyTotalOrder += value.totalCount;
              that.dailyTotalAmount += value.totalAmount;
              if (value.requestStatusId === RequestStatusEnum.Completed) {
                that.dailyTotalCompleted += value.totalCount;
              }
              if (value.requestStatusId !== RequestStatusEnum.Completed && value.requestStatusId !== RequestStatusEnum.Cancelled && value.requestStatusId !== RequestStatusEnum.Submitted && value.requestStatusId !== -1) {
                that.dailyTotalInProgress += value.totalCount;
              }
              if (value.requestStatusId === RequestStatusEnum.Cancelled) {
                that.dailyTotalCancelled += value.totalCount;
              }
            })
          }

        } else {
          this.toastrAlertService.errorToastr(res.errorMessage);
        }
      },
      error => {
        this.loaderService.hide();
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
        }
      }
    )
  }

  ngOnDestroy() {
    if (this.currentIntervalId && this.currentIntervalId !== null) {
      clearInterval(this.currentIntervalId);
    }
  }

  
  growthChartData = [{
    label: 'This year',
    data: [7, 10, 11, 9, 11, 16, 12, 15, 13, 8, 12, 10, 13, 10, 16, 15, 12, 8, 10, 7, 16, 12, 8, 9, 7, 12],
    borderWidth: 2.5,
    fill: false,
  }];

  growthChartLabels = ["A", "B", "C", "D", "E", "F", "g", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

  growthChartOptions = {
    responsive: true,
    scales: {
      yAxes: [{
        display: false,
        ticks: {
          autoSkip: true,
          maxTicksLimit: 10,
          stepSize: 35,
          beginAtZero: true,
        }
      }],
      xAxes: [{
        display: false,
        position: 'top',
        gridLines: {
          drawBorder: false,
          display: true,
          color: "#ededed",
        },
        ticks: {
          beginAtZero: true,
          autoSkip: true,
          maxTicksLimit: 12,
          stepSize: 20
        }
      }],

    },
    legend: {
      display: false,
    },
    elements: {
      point: {
        radius: 0
      }
    },
    tooltips: {
      backgroundColor: 'rgba(2, 171, 254, 1)',
    }
  };

  growthChartColors = [
    {
      backgroundColor: "#fb9678",
      borderColor: ['#fb9678'],
    }
  ];

  pageViewChartData = [{
    label: 'This year',
    data: [2, 4, 3, 3, 2, 3],
    borderWidth: 1,
    fill: false,
    pointBorderWidth: 1,
  }];

  pageViewChartLabels = ["2013", "2014", "2014", "2015", "2016", "2017"];

  pageViewChartOptions = {
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      xAxes: [{
        gridLines: {
          drawBorder: false,
          display: false
        },
        ticks: {
          display: false,
        }
      }],
      yAxes: [{
        gridLines: {
          drawBorder: false,
          display: false,
        },
        ticks: {
          display: false,
        }
      }]
    },
    legend: {
      display: false
    },
    tooltips: {
      enabled: false
    },
    layout: {
      padding: {
        top: 5,
        bottom: 5
      }
    }
  };

  pageViewChartColors = [
    {
      pointBackgroundColor: "#fff",
      backgroundColor: [
        'rgba(0,0,0,0)'
      ],
      borderColor: [
        '#caa8f9'
      ],
    }
  ];
  donationChartColors = [
    {
      pointBackgroundColor: "#fff",
      backgroundColor: [
        'rgba(0,0,0,0)'
      ],
      borderColor: [
        '#fff'
      ],
    }
  ];
  chartLineData = [
    {
      y: '2006',
      a: 50,
      b: 0
    },
    {
      y: '2007',
      a: 75,
      b: 78
    },
    {
      y: '2008',
      a: 30,
      b: 12
    },
    {
      y: '2009',
      a: 35,
      b: 50
    },
    {
      y: '2010',
      a: 70,
      b: 100
    },
    {
      y: '2011',
      a: 78,
      b: 65
    }
  ];

  public chartLineOptions = {
    grid: false,
    xkey: 'y',
    ykeys: ['a', 'b'],
    labels: ['Series A', 'Series B'],
    hideHover: "always",
    lineColors: ['#dadada', '#f29577']
  }


  monthlyAnalyticChartData = [{
    label: "Ios",
    pointRadius: 0,
    fill: true,
    borderWidth: 1,
    data: [0, 0, 30, 0, 0, 0, 50, 0]
  },
  {
    label: "Android",
    pointRadius: 0,
    fill: true,
    borderWidth: 1,
    data: [0, 35, 0, 0, 30, 0, 0, 0]
  },
  {
    label: "Windows",
    pointRadius: 0,
    fill: true,
    borderWidth: 1,
    data: [0, 0, 0, 40, 10, 50, 0, 0]
  }];

  monthlyAnalyticChartLabels = ['Jan', 'Feb', 'Mar', 'Arl', 'May', 'Jun', 'Jul', 'Aug'];

  monthlyAnalyticChartOptions = {
    maintainAspectRatio: false,
    legend: {
      display: false,
      position: "top"
    },
    scales: {
      xAxes: [{
        ticks: {
          display: true,
          beginAtZero: true,
          fontColor: 'rgba(0, 0, 0, 1)'
        },
        gridLines: {
          display: false,
          drawBorder: false,
          color: 'transparent',
          zeroLineColor: '#eeeeee'
        }
      }],
      yAxes: [{
        gridLines: {
          drawBorder: true,
          display: true,
          color: '#eeeeee',
        },
        categoryPercentage: 0.5,
        ticks: {
          display: true,
          beginAtZero: true,
          stepSize: 20,
          max: 80,
          fontColor: 'rgba(0, 0, 0, 1)'
        }
      }]
    },
  }

  monthlyAnalyticChartColors = [
    {
      borderColor: 'rgba(171, 140 ,228, 0.8)',
      backgroundColor: 'rgba(171, 140 ,228, 0.8)',
    },
    {
      borderColor: 'rgba(88, 216 ,163, 0.7)',
      backgroundColor: 'rgba(88, 216 ,163, 0.7)',
    },
    {
      borderColor: 'rgba(255, 180 ,99, 0.7)',
      backgroundColor: 'rgba(255, 180 ,99, 0.7)',
    }
  ];



  salesDifferenceData = [
    {
      y: '2006',
      a: 30,
      b: 0
    },
    {
      y: '2007',
      a: 75,
      b: 50
    },
    {
      y: '2008',
      a: 30,
      b: 12
    },
    {
      y: '2009',
      a: 55,
      b: 50
    },
    {
      y: '2010',
      a: 40,
      b: 60
    },
    {
      y: '2011',
      a: 60,
      b: 45
    },
    {
      y: '2012',
      a: 60,
      b: 35
    }
  ];

  public salesDifferenceOptions = {
    lineColors: ['#03a9f3', '#00c292'],
    fillOpacity: 0.1,
    xLabelMargin: 10,
    yLabelMargin: 10,
    grid: false,
    axes: false,
    xkey: 'y',
    ykeys: ['a', 'b'],
    labels: ['Series A', 'Series B'],
    hideHover: "always",
  }

  lastMonthAnalyticData = [
    {
      y: 'a',
      a: 30,
      b: 40
    },
    {
      y: 'b',
      a: 55,
      b: 65
    },
    {
      y: 'c',
      a: 60,
      b: 70
    },
    {
      y: 'd',
      a: 55,
      b: 45
    },
    {
      y: 'e',
      a: 40,
      b: 45
    }
  ];

  public lastMonthAnalyticOptions = {
    xkey: 'y',
    ykeys: ['a', 'b'],
    axes: 'x',
    labels: ['Series A', 'Series B'],
    barColors: ['#fe946b', '#b663e6'],
    barGap: 9,
    barSizeRatio: 0.55,
    hideHover: 'always',
    grid: false,
    resize: true
  }
 //#endregion
}
